
import ValidateException from "sap/ui/model/ValidateException";
import ParseException from "sap/ui/model/ParseException";
import FormatException from "sap/ui/model/FormatException";
import MCDate, { MCDateFormatOptions } from "./Date";
import CompositeType from "sap/ui/model/CompositeType";

export default class MCDateInterval extends CompositeType {
    private dateFormatter: MCDate;
    constructor(formatOptions?: MCDateFormatOptions) {
        super();
        this.dateFormatter = new MCDate(formatOptions);
    }
    public formatValue(values: Array<Date | string>): string | null {
        if (!values || !values.length) {
            throw new FormatException("No value to format") as Error;
        }
        const start = this.dateFormatter.formatValue(values[0]);
        const end = this.dateFormatter.formatValue(values[1]);
        return `${start} - ${end}`;
    }

    public parseValue(value: string): Array<Date> | null {
        if (!value || !value.length) {
            throw new ParseException("No value to parse") as Error;
        }
        const parts = value.split(" - ");
        if (parts.length !== 2) {
            throw new ParseException("Invalid interval format") as Error;
        }
        const start = this.dateFormatter.parseValue(parts[0]);
        const end = this.dateFormatter.parseValue(parts[1]);
        if (!start || !end) {
            throw new ParseException("Invalid date in interval") as Error;
        }
        return [start, end];
    }

    public validateValue(values: Array<Date | string>): void {
        if (!values || values.length !== 2) {
            throw new ValidateException("Interval must have exactly two dates") as Error;
        }
        const start = this.dateFormatter.parseValue(values[0] as string);
        const end = this.dateFormatter.parseValue(values[1] as string);
        if (!start || !end) {
            throw new ValidateException("Invalid date in interval") as Error;
        }
        if (start > end) {
            throw new ValidateException("Start date must be before end date") as Error;
        }
    }

}